import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import {
  PARAMETERS_INIT_FAIL,
  BUSCLS_INIT_LOADING,
  BUSCLS_INIT_SUCCESS,
  BUSCLS_INIT_FAIL,
  BUSCLS_MENU_LOADING,
  BUSCLS_MENU_SUCCESS,
  BUSCLS_MENU_FAIL,
  BUSCLS_TARF_LOADING,
  BUSCLS_TARF_SUCCESS,
  BUSCLS_TARF_FAIL,
  BUSCLS_COVER_LOADING,
  BUSCLS_COVER_SUCCESS,
  BUSCLS_COVER_FAIL,
  TARF_BENEFIT_LOADING,
  TARF_BENEFIT_SUCCESS,
  TARF_BENEFIT_FAIL,
  TARF_FACTOR_LOADING,
  TARF_FACTOR_SUCCESS,
  TARF_FACTOR_FAIL
} from '@/store/types'
export const busCls = {
  async busClsInit({ commit, state }) {
    const apiUrl = state.menu.busCls
    if (apiUrl) {
      commit(BUSCLS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(BUSCLS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(BUSCLS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PARAMETERS_INIT_FAIL, extractMessages(['Invalid API URL']))
    }
  },
  async busClsMenuInit({ commit, state }, busCls) {
    const apiUrl = state.busCls.menu.busClsGet
    if (apiUrl) {
      commit(BUSCLS_MENU_LOADING)
      const expand = {
        busCls: busCls
      }
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          data: result.data.data,
          menu: menu
        }
        commit(BUSCLS_MENU_SUCCESS, commitResult)
      } catch (error) {
        commit(BUSCLS_MENU_FAIL, extractMessages(error))
      }
    }
  },
  async busClsTariffInit({ commit, state }, expand) {
    const apiUrl = state.busCls.busClsMenu.menu.busClsTariffGet
    if (apiUrl) {
      commit(BUSCLS_TARF_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(BUSCLS_TARF_SUCCESS, commitResult)
      } catch (error) {
        commit(BUSCLS_TARF_FAIL, extractMessages(error))
      }
    }
  },
  async tariffBenefitInit({ commit, state }, expand) {
    const apiUrl = state.busCls.tariff.menu.tarfBenGet
    if (apiUrl) {
      commit(TARF_BENEFIT_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(TARF_BENEFIT_SUCCESS, commitResult)
      } catch (error) {
        commit(TARF_BENEFIT_FAIL, extractMessages(error))
      }
    }
  },
  async busClsCoverInit({ commit, state }, expand) {
    const apiUrl = state.busCls.busClsMenu.menu.busClsCoverGet
    if (apiUrl) {
      commit(BUSCLS_COVER_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(BUSCLS_COVER_SUCCESS, commitResult)
      } catch (error) {
        commit(BUSCLS_COVER_FAIL, extractMessages(error))
      }
    }
  },
  async tariffFactorInit({ commit, state }, expand) {
    const apiUrl = state.tariff.benefit.menu.tarfFactorGet
    if (apiUrl) {
      commit(TARF_FACTOR_LOADING)
      try {
        const result = await http.get(expandURI(apiUrl, expand))
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(TARF_FACTOR_SUCCESS, commitResult)
      } catch (error) {
        commit(TARF_FACTOR_FAIL, extractMessages(error))
      }
    }
  }
}
